module.exports = __webpack_public_path__ + "static/reviews-44bd77fc2f056fbefb86906936d58b3b.svg";